import { DeleteOcrAccountsApi } from "@/features/accounts/ocr/services/delete-accounts-api";
import { DeleteOcrAccountsRequestModel } from "@/features/accounts/ocr/services/delete-accounts-model";

/// OCR口座削除処理
export class DeleteOcrAccountsService {
  private deleteOcrAccountsApi = new DeleteOcrAccountsApi();
  /**
   * OCR口座削除API実行
   */
  public async deleteOcrAccounts(param: DeleteOcrAccountsRequestModel) {
    return await this.deleteOcrAccountsApi.deleteOcrAccounts(param);
  }
}
